import { render, staticRenderFns } from "./modal-noticias.vue?vue&type=template&id=eaa13878&scoped=true&"
import script from "./modal-noticias.vue?vue&type=script&lang=js&"
export * from "./modal-noticias.vue?vue&type=script&lang=js&"
import style0 from "./modal-noticias.vue?vue&type=style&index=0&id=eaa13878&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaa13878",
  null
  
)

export default component.exports